'use strict';

import { types } from './types';
import firebase from '../firebase/firebase';
import { toArray } from '../utils/lodashUtils';
import moment from 'moment';


const db = firebase.database();

export const getDBProviders = () => async dispatch => {
    return new Promise(function(resolve, reject) {
        const onGetProviders = (providersSnap) => {
            dispatch({
                type: types.GET_ALL_DB_PROVIDERS,
                payload: toArray(providersSnap.val())
            });
            resolve();
        }

        db.ref('/providers').once('value', onGetProviders);
    });
};

export const getProviderData = (providerId) => async dispatch => {
    return new Promise((resolve, reject) => {
        db.ref(`/providers/${providerId}/`).once('value', async providerDataSnap => {
            const providerData = providerDataSnap.val();
            let phoneNumberSnap = await db.ref(`clients/${providerId}/basicProfile/phone`).once('value', dataSnapshot => dataSnapshot, e => console.log)
            const phoneNumberVal = phoneNumberSnap.val();
            providerData['phone'] = phoneNumberVal;
            dispatch({
                type: types.GET_PROVIDER_DATA,
                payload: providerData
            });
            const actions = [
                {
                  payload: providerData && providerData.availability && providerData.availability.exception && providerData.availability.exception.exceptionArray,
                  type: types.GET_PROVIDER_EXCEPTIONS
                },
                {
                  payload: providerData && providerData.availability && providerData.availability.availabilityArray,
                  type: types.GET_PROVIDER_AVAILABILITY
                },
                {
                  payload: providerData && providerData.availability && providerData.availability.datesOff,
                  type: types.GET_PROVIDER_DAYSOFF
                }
            ];
            actions.map((action, i) => {
              if (action.payload) {
                dispatch({
                  type: action.type,
                  payload: {...action.payload}
                });
              };
            });
            resolve(true);
        }, (err) => {
            resolve(false);
            console.log('FIREBASE ERROR', err);
        })
        .catch(e=>{
            resolve(false);
            console.log(e, providerId);
        });
    });
};

export const resendProviderExceptions = (providerId, exceptionsToResend) => async dispatch => {
    console.log(exceptionsToResend);

    let tempResendDataRef = db.ref(`providers/${providerId}/tempResendData`);
    tempResendDataRef.set(exceptionsToResend);
};

export const deleteProviderException = (providerId, deleteDates, operationType) => async dispatch => {
    console.log(deleteDates);

    return new Promise((resolve, reject) => {
        db.ref(`providers/${providerId}/tempDeleteData`).set(deleteDates);
        db.ref(`providers/${providerId}/deleteOperationType`).set(operationType);

        const deleteOperationStatusRef = db.ref(`providers/${providerId}/deleteOperationStatus`);
        deleteOperationStatusRef.set('processing');

        deleteOperationStatusRef.off();
        deleteOperationStatusRef.on('value', deleteOperationStatusSnap => {
            const deleteOperationStatus = deleteOperationStatusSnap.val();
            if (deleteOperationStatus === "success") {
                resolve();
                console.log("Delete Operation Status: " + deleteOperationStatus);
                deleteOperationStatusRef.off();
                if (operationType === "deleteException") {
                    db.ref(`providers/${providerId}/availability/exception/exceptionArray`).once('value', exceptionsInCynoTimeSnap => {
                        const exceptionsInCynoTime = {...exceptionsInCynoTimeSnap.val()};
                        dispatch({
                            type: types.GET_PROVIDER_EXCEPTIONS,
                            payload: exceptionsInCynoTime ? exceptionsInCynoTime : {},
                        });
                    }, (err) => {
                        console.log('FIREBASE ERROR', err);
                    });
                }
                else if (operationType === "deleteExceptionDayOff") {
                    db.ref(`providers/${providerId}/availability/datesOff`).once('value', datesOffSnap => {
                        const datesOff = datesOffSnap.val();
                        dispatch({
                            type: types.GET_PROVIDER_DAYSOFF,
                            payload: datesOff ? datesOff : {},
                        });
                    }, (err) => {
                        console.log('FIREBASE ERROR', err);
                    });
                };
                dispatch({
                    type: types.SET_AVAILABILITY_UPDATE_STATUS,
                    payload: deleteOperationStatus
                });
                return 0;
            }
            else if (deleteOperationStatus === "failed") {
                resolve();
                console.log("Delete Operation Status: " + status);
                deleteOperationStatusRef.off();
                dispatch({
                    type: types.SET_AVAILABILITY_UPDATE_STATUS,
                    payload: deleteOperationStatus
                });
                return 0;
            };
        }, (err) => {
            console.log('FIREBASE ERROR', err);
        });
    });
};

export const setProviderAvailability = (providerId, sbmParamsAndAvailability, operationType) => async dispatch => {
    console.log(sbmParamsAndAvailability);
    const sbmParamsObjectSet = sbmParamsAndAvailability[0];
    const availabilityArrayInCynoTime = sbmParamsAndAvailability[1];
    let datesOff;
    // IF PERFORMING THIS OPERATION A REFERENCE TO TEMP DATESOFF DATA IS NEEDED
    if (operationType === "addExceptionDayOff") {
        datesOff = sbmParamsAndAvailability[2];
        db.ref(`providers/${providerId}/tempDatesOffData`).set(datesOff);
    }

    return new Promise((resolve, reject) => {
        db.ref(`providers/${providerId}/tempAvailabilityData`).set(sbmParamsObjectSet);
        db.ref(`providers/${providerId}/tempAvailabilityArray`).set(availabilityArrayInCynoTime);
        db.ref(`providers/${providerId}/availabilityOperationType`).set(operationType);

        const availabilityOperationStatusRef = db.ref(`providers/${providerId}/availabilityOperationStatus`);
        availabilityOperationStatusRef.set('processing');

        availabilityOperationStatusRef.off();
        availabilityOperationStatusRef.on('value', availabilityOperationStatusSnap => {
            let availabilityOperationStatus = availabilityOperationStatusSnap.val();
            if (availabilityOperationStatus === "success") {
                resolve();
                console.log("Availability Operation Status: " + availabilityOperationStatus);
                availabilityOperationStatusRef.off();

                if (operationType === "recurring") {
                    dispatch({
                        type: types.GET_PROVIDER_AVAILABILITY,
                        payload: availabilityArrayInCynoTime,
                    });
                }
                else if (operationType === "exception") {
                    dispatch({
                        type: types.GET_PROVIDER_EXCEPTIONS,
                        payload: availabilityArrayInCynoTime,
                    });
                }
                else if (operationType === "addExceptionDayOff") {
                    dispatch({
                        type: types.GET_PROVIDER_DAYSOFF,
                        payload: datesOff,
                    });
                };
                dispatch({
                    type: types.SET_AVAILABILITY_UPDATE_STATUS,
                    payload: availabilityOperationStatus
                });
                return 0;
            };
            if (availabilityOperationStatus === "failed") {
                resolve();
                console.log(availabilityOperationStatus);
                availabilityOperationStatusRef.off();
                dispatch({
                    type: types.SET_AVAILABILITY_UPDATE_STATUS,
                    payload: availabilityOperationStatus
                });
                return 0;
            };
        }, (err) => {
            console.log('FIREBASE ERROR', err);
        });
    });
};

// export const getClientProviderProfiles = (clientUID) => async dispatch => {
//     let clientProfiles = [];
//     db.ref(`/clients/${clientUID}/providers`).once('value', clientProvidersSnap => {
//         if (clientProvidersSnap.val()) {
//             console.log('PROVIDER_CLIENT',  providerClientsSnap.val());
//             toArray(clientProvidersSnap.val()).map(async clientProvider => {
//                 // TODO make a consile log tthat prints out variable name and the value in a colour that is specific ed and optional

//                 let profileSnap = await db.ref(`clients/${clientProvider._id}/basicProfile`).once('value')
//                     // , profileSnap => {
//                     console.log('GOT FB RESULT BACK',  profileSnap.val());
//                     const profile = profileSnap.val();
//                     profile.uid = clientProvider._id;
//                     providerProfiles.push(profile);

//                     dispatch({
//                         type: types.GET_CLIENT_PROVIDERS,
//                         payload: providerProfiles
//                     });
//             });
//         };
//     });
// }

export const getProviderClientProfiles = (providerUID) => async dispatch => {
    // return new Promise(function(resolve, reject) {
        try { // TODO: pass in clientData instead of getting it from Firebase
            let clientProfiles = [];
            db.ref(`/clients/${providerUID}/clients`).once('value', providerClientsSnap => {
                if (providerClientsSnap.val()) {
                    console.log('PROVIDER_CLIENT',  providerClientsSnap.val());
                    toArray(providerClientsSnap.val()).map(async providerClient => {
                        // TODO make a consile log tthat prints out variable name and the value in a colour that is specific ed and optional
                        console.log('providerClient', providerClient);

                        let profileSnap = await db.ref(`clients/${providerClient._id}/basicProfile`).once('value')
                            // , profileSnap => {
                            console.log('GOT FB RESULT BACK',  profileSnap.val());
                            const profile = profileSnap.val();
                            profile.uid = providerClient._id;
                            clientProfiles.push(profile);

                            dispatch({
                                type: types.GET_PROVIDER_CLIENTS,
                                payload: clientProfiles
                            });
                    });
                    // providerClientsSnap.forEach( async providerClientSnap => {
                        // console.log('PROVIDER CLIENT ID', providerClientSnap.val()._id);
                        // db.ref(`clients/${providerClientSnap.val()._id}/basicProfile`).once('value', profileSnap => {
                        //     console.log('GOT FB RESULT BACK',  profileSnap.val());

                        //     const profile = profileSnap.val();
                        //     profile.uid = providerClientSnap.val()._id;
                        //     clientProfiles.push(profile);
                        // });
                    // });
                    console.log('FOR EACH IS DONE');
                    console.log('PROFILES', clientProfiles);
                    // resolve(dispatch);
                };
            }, (error) => {
                console.log('FIREBASE ERROR', error);
            });
        } catch (error) {
            console.log('ERROR', error);
        }
        //resolve();
        //reject();
    // });
}

export const setSelectedClient = (client) => {
    if (client) {
        return {
            type: types.SET_SELECTED_CLIENT_SUCCESS,
            payload: client
        }
    } else {
        return {
            type: types.SET_SELECTED_CLIENT_FAIL,
        }
    }
};

const getServiceStatusListPerClient = (providerUserData) => {

    let servicesPerClient;
    // console.log('apUtils-GOT PROVIDER DATA', providerUserData);

    if (providerUserData && providerUserData.clients) {
        servicesPerClient = providerUserData.clients.map(providerClient => {
            const clientService = providerClient.services.map(service => {
                let apClientService = {};
                let apStatus = '';

                // Initialize tally for active and pending activePeriods for this service
                let apActive = 0;
                let apPending = 0;

                // console.log('apUtils-ACTIVE PERIODS', service.activePeriods);

                // TO DETERMINE THE SERVICE STATUS LOOP OVER EACH ACTIVE PERIOD TO DETERMINE IF WE ARE IN ONE CURRENTLY
                if (service._id){
                    service.activePeriods.map(activePeriod => {
                        let activePeriodStatus = {
                            isNowActive: false,
                            isNowPending: false,
                            isNowInactive: true
                        }

                        // console.log('apUtils-ACTIVE_PERIOD', activePeriod);
                        activePeriodStatus = getActivePeriodStatus(activePeriodStatus, activePeriod);
                        // console.log('apUtils-isCLIENTSERVICE:', activePeriodStatus.isNowPending, activePeriodStatus.isNowInactive, activePeriodStatus.isNowActive);

                        if (activePeriodStatus.isNowActive) apActive += 1;
                        if (activePeriodStatus.isNowPending) apPending += 1;

                    });

                        // console.log('apUtils-AP STATUS TALLY (active/pend)', apActive + '/' + apPending);

                        if ( apActive > 0) {
                            // console.log('apUtils-Active RUNNING');
                            apClientService = service;
                            apStatus = 'active';
                        }

                        if ( apActive === 0 && apPending === 0 ) {
                            // console.log('apUtils-Inactive RUNNING');
                            apClientService = service;
                            apStatus = 'inactive';
                        }

                        if (apActive === 0 && apPending > 0){
                            // console.log('apUtils-PENDING RUNNING');
                            apClientService = service;
                            apStatus = 'pending';
                        }

                        return {serviceId: apClientService._id, status: apStatus}
                    //   return {client: apProviderClient.uid, service: apClientService._id, status: apStatus}
                }
            });
        // console.log('apUtils-clientService',clientService)
        return { clientUid: providerClient.uid, services: clientService.filter((service => service !== undefined))}
        });
        // console.log('apUtils-servicesPerClient', servicesPerClient)
        return servicesPerClient
    }
}

const getActivePeriodStatus = (activePeriodStatus, activePeriod) => {
    const utcActivePeriodStart = activePeriod.utcActivePeriodStartTimestamp;
    const utcActivePeriodEnd = activePeriod.utcActivePeriodEndTimestamp;
    const currentUtcTimestamp = moment.utc().format('x');

    if (currentUtcTimestamp > utcActivePeriodStart && currentUtcTimestamp < utcActivePeriodEnd) {
        activePeriodStatus.isNowActive = true;
        activePeriodStatus.isNowInactive = false;
    }
    // IF ANY START DATE IS GREATER THAN THE UTC TIME THEN IT IS PENDING OTHERWISE IT IS INACTIVE IF THERE IS NO START DATES GREATER THAN UTC NOW

    if (currentUtcTimestamp < utcActivePeriodStart) {
        activePeriodStatus.isNowPending = true;
        activePeriodStatus.isNowInactive = false;
    }

    return activePeriodStatus;
}

// THIS IS HERE BECAUSE CLIENT ACTIONS ARE ACTUALLY USER ACTIONS (NEEDS TO BE RENAMED) AND ONLY PROVIDERS HAVE CLIENTS
export const filterClientProfileByActivityStatus = (providerUserData) => dispatch => {
    console.log('RUNNING FILTER CLIENTS');
    // console.log('filterClientProfileByActivityStatus-providerUserData', providerUserData)
    // console.log('filterClientProfileByActivityStatus-clients', clients)
    //console.log('filterClientProfileByActivityStatus-getServiceStatusListPerClient', getServiceStatusListPerClient(providerUserData))

    providerUserData.clients && providerUserData.clients.map(clientProfile => {
        const clientListWithServiceStatusList = getServiceStatusListPerClient(providerUserData);
        clientListWithServiceStatusList.map(client => {
            if (client.clientUid === clientProfile.uid) {
                let pending = 0;
                let active = 0;

                client.services.map(clientService => {
                    // console.log('clientService', clientService.client)
                    // console.log('PROFILE UID', clientProfile, profile.uid);

                    // IF ANY SERVICES ARE ACTIVE OR PENDING ADD THEM TO THE TALLY
                    if (clientService.status === 'pending') {
                        pending += 1;
                    }
                    if (clientService.status === 'active') {
                        active += 1;
                    }
                    // console.log('clientService-status', 'clientProfile:' + clientProfile, active + '/' + pending);

                });
                if (active > 0) {
                    // CLIENT IS ACTIVE
                    // console.log('SETTING ACTIVE CLIENT (A/P)',  active + '/' + pending);
                    dispatch({
                        type: types.ADD_ACTIVE_CLIENT_SUCCESS,
                        payload: clientProfile
                    })
                } else if (active === 0 && pending > 0) {
                    // CLIENT IS PENDING
                    // console.log('SETTING PENDING CLIENT (A/P)',  active + '/' + pending);
                    dispatch({
                        type: types.ADD_PENDING_CLIENT_SUCCESS,
                        payload: clientProfile
                    })
                } else if (active === 0 && pending === 0) {
                    // CLIENT IS INACTIVE
                    // console.log('SETTING INACTIVE CLIENT (A/P)',  active + '/' + pending);
                    dispatch({
                        type: types.ADD_INACTIVE_CLIENT_SUCCESS,
                        payload: clientProfile
                    })
                }
            }

        });
    });

    return {
        type: types.ADD_CLIENT_BY_STATUS_FAIL
    }
  }


// WEBPACK FOOTER //
// ./src/js/actions/provider-actions.js